
export const requiredIndex = (text) => {
  return <span>{text}<span style={{color: '#DE1F1F'}}>*</span></span>
}